import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/order', // 交易
  name: 'order',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.order',
    requiresAuth: true,
    icon: 'icon-stamp',
    order: 4,
  },
  children: [
    {
      path: 'purchaseOrderManage', // The midline path complies with SEO specifications
      name: 'purchaseOrderManage',
      component: () => import('@/views/transaction/purchaseOrder/index.vue'),
      meta: {
        locale: 'menu.purchaseOrderManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'saleOrderManage', // The midline path complies with SEO specifications
      name: 'saleOrderManage',
      component: () => import('@/views/transaction/saleOrder/index.vue'),
      meta: {
        locale: 'menu.saleOrderManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
